<template>
 
    <NavBar />

    <div class="main-content">
      <div class="sidebar">
        <div class="section-link" id="about-me-link" data-section="about-me">
          <span class="dash"></span>
          <span class="section-name">About Me</span>
        </div>
        <div class="section-link" id="education-link" data-section="education">
          <span class="dash"></span>
          <span class="section-name">Education</span>
        </div>
        <div class="section-link" id="experience-link" data-section="experience">
          <span class="dash"></span>
          <span class="section-name">Experience</span>
        </div>
        <div class="section-link" id="skills-link" data-section="skills">
          <span class="dash"></span>
          <span class="section-name">Skills</span>
        </div>
        <div class="section-link" id="interests-link" data-section="interests">
          <span class="dash"></span>
          <span class="section-name">Interests</span>
        </div>
      </div>

      <!-- Sections -->
      <div class="sections">
        <!-- About Me -->
        <div class="section" id="about-me">
          <div class="text-container">
            <span>Hey! I'm Ashhad, I love designing software applications through methodical practices and bringing them to life with robust coding principles</span>
            <span><br>I am a programmer and problem-solver in all sense, I have contributed to the development of a multitude of projects across different domains that have helped me grow as a holistic software developer</span>
            <span><br>From building user-facing full stack web applications, training and fine-tuning ML models, crafting data pipelines, exploring and visualizing complex data to researching AI theories and principles within NLP and Vision, I have experienced it all!</span>
          </div>
          <div class="image-container">
            <img src="image1.png" alt="Image 1">
          </div>
        </div>

        <!-- Education -->
        <div class="section" id="education">
          <div class="education-container">
            <div class = "education-subsection">
              <h3> <br>Saint Cloud State University </h3>  
              <p> Masters in Computer Science</p>
              <img src="Campus-SCSU.png" alt="Image 3">
            </div>
            <div class = "education-subsection">
              <h3> <br>Osmania University </h3>  
              <p> Bachelors in Computer Science </p>
              <img src="MJCET.png" alt="Image 4">
            </div>
          </div>
        </div>

        <!-- Experience -->
        <div class="section" id="experience">
          <div class="text-container">
            <h3><br> <b>AI Developer | Analyst at St. Cloud State </b></h3>
            <span>Built agentic AI applications, data integration solutions for university services and other cool stuff!</span>
            <h3><br><br><b>Graduate Research and Teaching Assistant at COSE-ISELF, SCSU </b></h3>
            <span> Performed AI research and assisted faculty in software engineering coursework, built accessiblityi friendly applications, systems software  </span>
            <h3><br><br> <b>Software Developer at AIS </b> </h3>
            <span> Worked on backend optimization , data ingestion and architecture </span>
          </div>
          <div class="image-container">
            <img src="MC220.png" alt="Image 5">
          </div>
        </div>

        <!-- Skills -->
        <div class="section" id="skills">
          <div class="text-container">
            <span>I am a dedicated Computer Science professional with over 7 years of academic and hands-on experience across software engineering, data platforms, and cloud-native development</span>

            <div>
                <span><br><strong>Languages:</strong> Proficient in Java, C# and Python; experienced with JavaScript and C/C++</span>
                <span><strong>Full-Stack:</strong> Backend expertise with Spring Boot, ASP.NET Core, Django, and Node.js; frontend development with React, Vue, and Dash</span>
                <span><strong>Databases:</strong> Experienced in design and management using PostgreSQL, MySQL, MS SQL Server, Redis, and MongoDB</span>
                <span><strong>Machine Learning & AI:</strong> Practical experience with PyTorch, TensorFlow, OpenCV, scikit-learn, Hugging Face, and LangChain for building and integrating intelligent systems</span>
                <span><strong>Cloud Platforms:</strong> Azure (strongest), AWS, and GCP (familiar with core services)</span>
                <span><strong>Distributed Systems & Data:</strong> Spark for parallel data processing; Kafka and RabbitMQ for event-driven architectures and messaging systems</span>
                <span><strong>DevOps & CI/CD:</strong> Skilled with Git, Docker, Kubernetes, Jenkins, Airflow, and Terraform for automated workflows and scalable deployments</span>
            </div>

            <span><br>I actively explore new technologies, frameworks, and paradigms to stay current and build future-ready systems.</span>
          </div>
          <div class="image-container">
            <img src="cs.png" alt="Image 8">
          </div>
        </div>

        <!-- Interests -->
        <div class="section" id="interests">
          <div class="text-container">
            <span><br>Outside of technology, I enjoy weight training, athletics, reading books, playing outdoor team sports</span>
          </div>
          <div class="image-container">
            <img src="gym.png" alt="Image 9">
          </div>
        </div>
      </div>
    </div>
</template>


<script>
export default{
    mounted() {

    document.querySelector('#about-me-link').classList.add('active');
      
    document.querySelector('#about-me-link').addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    // Get all section links
    // const sectionLinks = document.querySelectorAll('.section-link');
    //get all seciton links except with id #about-me-link
    const sectionLinks = document.querySelectorAll('.section-link:not(#about-me-link)');

    // Add event listener to each section link
    sectionLinks.forEach((link) => {
      link.addEventListener('click', () => {
        // Get the section ID from the data-section attribute
        const sectionId = link.getAttribute('data-section');
        // Get the section element
        const section = document.getElementById(sectionId);
        // Scroll to the section
        section.scrollIntoView({ behavior: 'smooth',  block: 'center' });
        // Remove active class from all section links
        sectionLinks.forEach((otherLink) => {
          otherLink.classList.remove('active');
        });
        // Add active class to the clicked section link
        link.classList.add('active');
      });
    });

    // Add event listener to the window to detect scroll position
    window.addEventListener('scroll', () => {
      // Get the current scroll position
      // const scrollPosition = window.scrollY;
      // Get the sections
      const sections = document.querySelectorAll('.section');
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const sectionLink = document.querySelector(`.section-link[data-section="${section.id}"]`);
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
          // Add active class to the section link
          sectionLink.classList.add('active');
        } else {
          // Remove active class from the section link
          sectionLink.classList.remove('active');
        }
      });
    });

  }

}
</script>


<style scoped>

@import url('https://fonts.googleapis.com/css?family=Merriweather|Montserrat');
@import url('https://fonts.googleapis.com/css?family=Inter:400,700&display=swap');

/* Global Styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Merriweather', sans-serif;
  color: #333;
  background-color: #f9f9f9;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Playfair Display', serif;
}

h3 {
  font-size: 1.2em;
}

p {
  font-family: 'Inter', sans-serif;
  font-weight: 400; /* regular weight */
  font-style: normal; /* normal style */
  color: #333;
  background-color: #ffffff;
}

span{
  font-family: 'Inter', sans-serif;
  font-weight: 400; /* regular weight */
  font-style: normal; /* normal style */
  color: #333;
  background-color: #ffffff;
  display: block;
  text-align: left;
}

/* Main Content */
.main-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.5em;
}

/* Sidebar */
.sidebar {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 300px;
  background-color: transparent;
  padding: 20px;
  border-radius: 10px;
  margin-left: 25px;
}

.section-link {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  cursor: pointer;
  font-size: 1.2em;
}

.dash {
  width: 5px;
  height: 20px;
  background-color: #ccc;
  margin-right: 10px;
  transition: background-color 0.3s ease;
}

.section-name {
  color: #333;
}

.section-link:hover .dash{
  background-color: #84b9f1;
}

.section-link:hover .section-name{
  color: #84b9f1;
}

.section-link.active .dash {
  background-color:  #007BFF;
}

.section-link.active .section-name {
  color: #007BFF;
}

/* Sections */
.sections {
  width: 100%;
  padding: 2em;
  padding-top: 60px;
}

.section {
  background-color: #fff;
  padding: 1.5em;
  margin-bottom: 2em;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-left: 200px;
  display: flex;
}

#education {
  display: flex;
  flex-direction: column;
}

.text-container {
  width: 50%;
  padding: 1em;
}

.text-container p {
  text-align: justify;
}


.image-container {
  width: 50%;
  padding: 1em;
}

.image-container img {
  width: 100%;
  height: 80%;
  object-fit: cover;
  border-radius: 10px;

}


.education-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.education-subsection {
  flex-basis: 45%;
  margin: 0px;
  padding: 20px;
}

.education-subsection h3 {
  margin-bottom: 10px;
}

.education-subsection p {
  margin-bottom: 20px;
}

.education-subsection img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 10px;
}

  /*--------MOBILE------------*/
  @media screen and (max-width: 745px) {

    .sidebar{
      display: none;
    }

    .section{
      display: flex;
      margin: auto;
      overflow: hidden;
      margin-bottom: 1.5em;
    }

  }
</style>